/* Greek Superherbs — product page enhancements: variant pill pricing + sticky buy bar. */
(function () {
'use strict';

function money(cents, symbol) {
var v = (cents / 100).toFixed(2);
if (v.slice(-3) === '.00') v = v.slice(0, -3);
return (symbol || '$') + v;
}

function cupsFrom(text) {
var m = /(\d+)\s*cups?/i.exec(text || '');
return m ? parseInt(m[1], 10) : 0;
}

function enhancePills(section) {
var picker = section.querySelector('variant-radios');
if (!picker) return;
var dataEl = picker.querySelector('script[type="application/json"]');
if (!dataEl) return;
var variants;
try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }
var symbol = section.getAttribute('data-currency') || '$';
var fieldsets = picker.querySelectorAll('fieldset');
if (fieldsets.length !== 1) return; // pricing per pill is only unambiguous for single-option products

var inputs = fieldsets[0].querySelectorAll('input[type="radio"]');
var rows = [];
inputs.forEach(function (input) {
var label = fieldsets[0].querySelector('label[for="' + input.id + '"]');
if (!label) return;
var variant = variants.filter(function (v) { return v.option1 === input.value; })[0];
if (!variant) return;
var cups = cupsFrom(input.value);
rows.push({ input: input, label: label, variant: variant, cups: cups, perCup: cups ? variant.price / cups : 0 });
});
if (!rows.length) return;
var basePerCup = rows[0].perCup;

rows.forEach(function (r) {
if (r.label.querySelector('.gsx-pill-name')) return;
var raw = r.input.value;
var name = raw.replace(/^organic\s*/i, '').replace(/\s*\(\d+\s*cups?\)\s*/i, '').replace(/\bpounds?\b/i, 'lb').replace(/\bounces?\b/i, 'oz').trim();
var sub = r.cups ? r.cups + ' cups' : '';
var save = '';
if (basePerCup && r.perCup && r.perCup < basePerCup - 0.5) {
save = '<span class="gsx-pill-save">Save ' + Math.round((1 - r.perCup / basePerCup) * 100) + '%</span>';
}
var meta = money(r.variant.price, symbol) + (r.perCup ? '<small>' + money(Math.round(r.perCup), symbol) + ' per cup</small>' : '');
if (!r.variant.available) meta = 'Sold out';
r.label.innerHTML =
'<span class="gsx-pill-name">' + name + save + (sub ? '<small>' + sub + '</small>' : '') + '</span>' +
'<span class="gsx-pill-meta">' + meta + '</span>';
});
}

function initSticky(bar) {
var main = document.querySelector('[data-gsx-pdp]');
if (!main) return;
var submit = main.querySelector('.product-form__submit');
var priceBox = main.querySelector('[id^="price-"]');
if (!submit) return;
var btn = bar.querySelector('[data-gsx-sticky-btn]');
var priceOut = bar.querySelector('[data-gsx-sticky-price]');
var btnLabel = btn.getAttribute('data-label') || 'Add to cart';

function readPrice() {
// Prefer the purchase option selected in the subscription widget (Loop), so the
// bar shows the subscription price when "Subscribe & Save" is selected.
var loopSel = main.querySelector('.loop-widget-purchase-option-selected .loop-widget-purchase-option-price');
var txt = '';
if (loopSel && loopSel.textContent.trim()) txt = loopSel.textContent;
else if (priceBox) {
var el = priceBox.querySelector('.price__sale .price-item--sale') || priceBox.querySelector('.price__regular .price-item--regular') || priceBox.querySelector('.price-item');
txt = el ? el.textContent : '';
}
txt = txt.replace(/\s+/g, ' ').replace(/\s?USD/g, '').trim();
// Split "$16.90 ($0.85/cup)" into price + per-cup note (per-cup is hidden on small screens).
var m = /^(.*?)\s*(\([^)]*cup[^)]*\))\s*$/i.exec(txt);
return m ? { price: m[1].trim(), note: m[2] } : { price: txt, note: '' };
}
function sync() {
if (priceOut) {
var p = readPrice();
priceOut.textContent = p.price;
var note = priceOut.nextElementSibling;
if (note && note.hasAttribute('data-gsx-sticky-note')) note.textContent = p.note;
}
var disabled = submit.hasAttribute('disabled');
btn.disabled = disabled;
var mainText = (submit.querySelector('span') || submit).textContent.trim();
btn.querySelector('span').textContent = disabled ? mainText || 'Sold out' : (mainText || btnLabel);
}
sync();
if (priceBox) new MutationObserver(sync).observe(priceBox, { childList: true, subtree: true, characterData: true });
new MutationObserver(sync).observe(submit, { attributes: true, childList: true, subtree: true });
var loopBox = main.querySelector('.loop-widget-container');
if (loopBox) new MutationObserver(sync).observe(loopBox, { attributes: true, childList: true, subtree: true, characterData: true });
else {
// Loop renders after load; pick it up once it appears.
var lateLoop = new MutationObserver(function () {
var lb = main.querySelector('.loop-widget-container');
if (lb) { lateLoop.disconnect(); new MutationObserver(sync).observe(lb, { attributes: true, childList: true, subtree: true, characterData: true }); sync(); }
});
lateLoop.observe(main, { childList: true, subtree: true });
}

btn.addEventListener('click', function () {
if (btn.disabled) return;
submit.click();
var drawer = document.querySelector('cart-drawer, #CartDrawer');
if (!drawer) submit.scrollIntoView({ behavior: 'smooth', block: 'center' });
});

// Visibility: re-query the live submit button on every scroll (apps such as
// Loop / Essential can re-render the product form after load).
var footer = document.querySelector('.footer, footer');
var ticking = false;
function update() {
ticking = false;
var live = main.querySelector('.product-form__submit') || submit;
var r = live.getBoundingClientRect();
var past = r.bottom < 0;
if (past && footer) {
var fr = footer.getBoundingClientRect();
if (fr.top < window.innerHeight * 0.6) past = false;
}
bar.classList.toggle('is-visible', past);
// Lift fixed widgets (Shopify Inbox chat launcher) above the bar while it is showing.
document.documentElement.classList.toggle('gsx-sticky-open', past);
if (past) document.documentElement.style.setProperty('--gsx-sticky-h', bar.offsetHeight + 'px');
}
function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
window.addEventListener('scroll', onScroll, { passive: true });
window.addEventListener('resize', onScroll);
update();
}

function init() {
document.querySelectorAll('[data-gsx-pdp]').forEach(enhancePills);
document.querySelectorAll('[data-gsx-sticky]').forEach(function (bar) {
if (bar.__gsx) return; bar.__gsx = true; initSticky(bar);
});
}

if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
document.addEventListener('shopify:section:load', init);
})();
